<template>
    <div class="painel-full">
        <header class="painel-full-header">
            <slot name="cabecalho"></slot>
        </header>

        <main class="painel-full-conteudo">
            <slot name="corpo"></slot>
        </main>

        <footer class="painel-full-rodape">
            <slot name="rodape"></slot>
        </footer>
    </div>
</template>

<style scoped>
.painel-full {
    display: flex;
    min-height: 100%;
    flex-direction: column;
    background: #fff;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08);
    border-radius: 3px;
}

.painel-full-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 52px;
    border-bottom: 1px solid #e0e0e0;
}

.painel-full-cabecalho {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.painel-full-conteudo {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.painel-full-rodape {
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-top: 1px solid #ccc;
}
</style>
